<div class="min-h-screen flex items-center justify-center p-4">
    <div class="border-2 border-opacity-25 rounded-2xl p-5 w-full md:w-4/5 lg:w-3/5 xl:w-1/2 shadow-[0_2px_22px_-4px_rgba(93,96,127,0.2)]">
        <!-- Contenedor Formulario Registro -->
        <div>
            <div class="m-5 flex justify-center">
                <h1 class="text-lg font-bold text-azul">{{'crear-cuenta' | translate}}</h1>
            </div>
            <!-- Formulario Registro -->
            <form [formGroup]="formRegistro" (ngSubmit)="registrarUsuario()">
                <!-- Nombre -->
                <div class="m-5 mb-7 flex justify-center">
                    <mat-form-field class="w-full md:w-2/3" appearance="outline" hideRequiredMarker>
                        <mat-label class="bg-white p-1">{{'Nombre' | translate}}</mat-label>
                        <input type="text" matInput formControlName="nombre" placeholder="{{'introduce-tu-nombre' | translate}}">
                        <mat-error *ngIf="controlarErrores('nombre', 'required')">{{'introduce-tu' | translate}} <strong>{{'nombre' | translate}}</strong></mat-error>
                        <mat-error *ngIf="controlarErrores('nombre','minlength') && !controlarErrores('nombre','pattern')">{{'nombre-debe' | translate}} <strong>{{'tres-o-mas' | translate}}</strong></mat-error>
                        <mat-error *ngIf="controlarErrores('nombre','maxlength') && !controlarErrores('nombre','pattern')">{{'nombre-supera' | translate}} <strong>{{'maximo-caracteres'  | translate}}</strong></mat-error>
                        <mat-error *ngIf="controlarErrores('nombre','pattern') && (!controlarErrores('nombre','minlength') || !controlarErrores('nombre','maxlength'))">{{'nombre-no-puede-contener' | translate}} <strong>{{'numeros-caracteres' | translate}}</strong></mat-error>
                    </mat-form-field>
                </div>
                
                <!-- Correo Electronico -->
                <div class="m-5 mb-7 flex justify-center">
                    <mat-form-field class="w-full md:w-2/3" appearance="outline" hideRequiredMarker>
                        <mat-label class="bg-white p-1">{{'Correo-Electronico' | translate}}</mat-label>
                        <input type="email"  matInput formControlName="email" placeholder="{{'Correo-Electronico' | translate}}">
                        <mat-error *ngIf="controlarErrores('email', 'required')">{{'introduce-una-direccion' | translate}} <strong>{{'correo-electronico' | translate}}</strong></mat-error>
                        <mat-error *ngIf="controlarErrores('email','email')">{{'direccion-correo' | translate}} <strong>{{'no-valida' | translate}}</strong></mat-error>
                    </mat-form-field>
                </div>

                <!-- Contraseña -->
                <div class="m-5 mb-7 flex justify-center">
                    <mat-form-field class="w-full md:w-2/3" appearance="outline" hideRequiredMarker>
                        <mat-label class="bg-white p-1">{{'introduce-tu-password' | translate}}</mat-label>
                        <input matInput [type]="mostrarPassword ? 'text' : 'password'" formControlName="password" placeholder="{{'introduce-tu-password' | translate}}" (focus)="mostrarInfoPassword()" (focusout)="ocultarInfoPassword()">
                        <mat-icon matSuffix (click) = 'cambiarVisibilidadPassword()'>{{mostrarPassword ? 'visibility_off':'visibility'}}</mat-icon>                            <mat-error *ngIf="controlarErrores('password', 'required')">{{'introduce-tu' | translate}} <strong>{{'password' | translate}}</strong></mat-error>
                        <mat-error *ngIf="controlarErrores('password', 'minlength') && !controlarErrores('password','required')">{{'password-debe' | translate}} <strong>{{'mas-ocho-carateres' | translate}}</strong></mat-error>
                        <mat-error  *ngIf="controlarErrores('password', 'pattern') && !controlarErrores('password','minlength')">{{'Password' | translate}} <strong>{{'no-valida' | translate}}</strong></mat-error>
                    </mat-form-field>
                </div>

                <!-- Formato Contraseña -->
                <div class="m-5 flex justify-center" *ngIf="infoPassword">
                    <nz-alert class="w-full md:w-2/3" nzType="info" nzMessage="{{'text-info-password' | translate}}" nzShowIcon></nz-alert> 
                </div>
    
                <!--Confirmacion Contraseña -->
                <div class="m-5 flex justify-center">
                    <mat-form-field class="w-full md:w-2/3" appearance="outline" hideRequiredMarker>
                        <mat-label class="bg-white p-1">{{'vuelve-password' | translate}}</mat-label>
                        <input matInput [type]="mostrarPassword ? 'text' : 'password'" formControlName="validacionPassword" placeholder="{{'introduce-tu-password' | translate}}">
                        <mat-icon matSuffix (click) = 'cambiarVisibilidadPassword()'>{{mostrarPassword ? 'visibility_off':'visibility'}}</mat-icon>
                        <mat-error *ngIf="controlarErrores('validacionPassword', 'required')">{{'introduce-tu' | translate}} <strong>{{'password' | translate}}</strong></mat-error>
                    </mat-form-field>
                </div>
                    
                <div class="flex justify-center">
                    <button type="submit" [disabled]="!formRegistro.valid" class="p-2 bg-azul text-white w-full md:w-1/2 rounded-full">{{'crear-cuenta' | translate}}</button>
                </div>    
            </form>
            
            <!-- Formulario Inicio Sesion -->
            <div class="m-5 flex justify-center">
                <div class="space-x-1">
                    <span>{{'ya-tienes-cuenta' | translate}}</span>
                    <a routerLink="/inicioSesion" class="text-azul"><strong>{{'inciar-sesion-aqui' | translate}}</strong></a>
                </div>
            </div>
            
            <!-- Volver Inicio -->
            <div class="m-5 flex justify-end">
                <div class="space-x-1">
                    <a href="/" class="text-azul flex items-center"><mat-icon>keyboard_arrow_left</mat-icon><span><strong>{{'volver-inicio' | translate}}</strong></span></a>
                </div>
            </div>
            
            <!-- Contenedor Errores -->
            <div>
                <!-- Error contreseñas no coinciden -->
                <div *ngIf="mostrarErrorPasswords">
                    <nz-alert nzType="error" nzCloseable (nzOnClose)="cerrarAlerta()" nzMessage="{{'err-ru' | translate}}" nzDescription="{{'text-err-ru-pass' | translate}}" nzShowIcon></nz-alert>
                </div>
                <!-- Error Correo Electronico existente-->
                <div *ngIf="mostrarErrorRegistro">
                    <nz-alert nzType="error" nzCloseable (nzOnClose)="cerrarAlerta()" nzMessage="{{'err-ru' | translate}}" nzDescription="{{'text-err-ru' | translate}}" nzShowIcon></nz-alert>
                </div>
            </div>
        </div>
    </div>
</div>


